import { ExpandOnInitState, KendoTree } from "../core/components/kendoTree.js";
import { Helper } from "../core/util/helper.js";
import { HTTPService, JsonResultClass } from "../core/util/httpManager.js";
import { NotificationHelper } from "../core/util/notificationHelper.js";
import { DocumentFolderStructureTreeFilter } from "./documentFolderStructureTreeFilter.js";
import { DocumentFolderStructure, DocumentFolderStructureTreeVm, DocumentListItem } from "./documents.js";
import React from "react";
export interface DocumentFolderStructureTreeProps {
    type: number;
    documents: DocumentListItem[];
    withDocuments: boolean;
    onSelectionChanged?: (dataItem: DocumentFolderStructure, parentNode: DocumentFolderStructure, start: Date, end: Date) => void;
    expandOnInitState?: ExpandOnInitState;
    showFilter?: boolean;
    onDataLoaded?: (vm: DocumentFolderStructureTreeVm) => void;
    selectedDocument?: DocumentListItem;
}

export default class DocumentFolderStructureTree extends React.Component<DocumentFolderStructureTreeProps, {
    selectedNode: DocumentFolderStructure;
    vm: DocumentFolderStructureTreeVm;
    start: Date;
    end: Date;
}>{

    constructor(props) {
        super(props);
        this.state = {
            selectedNode: null,
            vm: null,
            start: null,
            end: null
        };
    }

    componentDidMount() {
        this.loadData();
    }

    componentDidUpdate(prevProps, prevState) {
        if (this.props.documents != prevProps.documents
            || this.props.type != prevProps.type
            || this.props.withDocuments != prevProps.withDocuments)
            this.loadData();
    }

    private loadData = async () => {
        const resultTreeData: JsonResultClass<DocumentFolderStructureTreeVm> = await HTTPService.post<JsonResultClass<DocumentFolderStructureTreeVm>>(`DocumentFolderStructure/GetDocumentsTreeData`, {
            type: encodeURIComponent(this.props.type),
            documents: this.props.documents,
            withDocuments: this.props.withDocuments
        });

        if (resultTreeData.Code == 0)
            this.setState({ vm: resultTreeData.Data }, () => {
                if (Helper.hasValue(this.props.onDataLoaded))
                    this.props.onDataLoaded(resultTreeData.Data);
            });
        else
            NotificationHelper.showErrorMessage(resultTreeData.Message);
    }

    private getTemplate(dataItem) {
        let item: DocumentFolderStructure = dataItem.item;

        let text = item.TranslatedDescription;
        let typIcon = `<i class='fal fa-folder' title='${Helper.getTranslation("WebSMS.Skills.Folder")}' />`;
        let tooltip = text;

        if (item.IsDocument) {
            text = item.TranslatedDescription;
            typIcon = `<i class='fal fa-file' title='${Helper.getTranslation("SmartSearch.SearchType.doc")}' />`;
            tooltip = text;
        }

        return `<div style='display: flex;'>
                    <div>${typIcon}</div>
                    <label style='margin-left: 5px; display: inline-block; margin-right: 5px; white-space: nowrap; text-overflow: ellipsis; overflow: hidden; width: 200px;' title='${tooltip}'>
                        ${text}
                    </label> 
                </div>`;
    }

    private onSelectionChange = (dataItem: DocumentFolderStructure) => {
        this.setState({ selectedNode: dataItem }, () => {
            this.doSelectionChanged();
        });
    }
    
    private doSelectionChanged = (): void => {
        let dataItem = this.state.selectedNode;
        if (Helper.hasValue(this.props.onSelectionChanged)) {
            let parentNode: DocumentFolderStructure = null;
            if (dataItem.IsDocument)
                parentNode = this.findNodeWithId(this.state.vm.TreeData, dataItem.ParentId);
            this.props.onSelectionChanged(dataItem, parentNode, this.state.start, this.state.end);
        }
    }
    
    private findNodeWithId(nodes: DocumentFolderStructure[], id: string): DocumentFolderStructure {
        for (let node of nodes) {
            if (node.Id == id) return node;
            if (node.Children.length > 0) {
                let childNode = this.findNodeWithId(node.Children, id);
                if (childNode != null) return childNode;
            }
        }
        return null;
    }

    private onFilterChange = (model, value) => {
        switch (model) {
            case "Start":
                this.setState({ start: value }, () =>  {
                    this.doSelectionChanged();
                });
                break;
            case "End":
                this.setState({ end: value }, () =>  {
                    this.doSelectionChanged();
                });
                break;
        }
    }

    private getKendoTree = () => {
        return <KendoTree
            treeData={this.state.vm?.TreeData}
            template={(dataItem) => this.getTemplate(dataItem)}
            refreshOnTreeDataChanged={true}
            showExpandAndCollapseIcons={true}
            onSelectionChange={this.onSelectionChange}
            expandOnInitState={this.props.expandOnInitState}
            selectedNodeId={this.props.selectedDocument?.RefId}
            showSelectFirstNodeIcon={true}
        />
    }

    render() {
        let filter = this.props.showFilter ? <DocumentFolderStructureTreeFilter onChange={this.onFilterChange} /> : null;
        let tree = this.getKendoTree();

        return (<>
            {filter}
            {tree}
        </>)
    }
}